/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Container, Dropdown, Row } from "react-bootstrap";
import Card from "../../Common/Card/Card";
import { GetUpcomingEvents } from "../../services/Web.type.js";
import { usePostQuery } from "../../hooks/reactQueryHelper.js";
import CheckboxItem from "../../Common/Dropdown/CheckboxItem.js";
import SkeletonCard from "../../Common/loader/Loader.js";
import BlankPage from "../../Common/BlankData/BlankPage.js";

const Event = () => {
  const [searchValue, setSearchValue] = useState("");
  const [selectedEventTypes, setSelectedEventTypes] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const pathname = window.location.pathname;

  const options = [
    {
      value: 1,
      label: "Cycling",
      icon: "/media/assets/svg/directions-bike.svg",
    },
    {
      value: 2,
      label: "Walking",
      icon: "/media/assets/svg/directions-walk.svg",
    },
    {
      value: 3,
      label: "Running",
      icon: "/media/assets/svg/directions-run.svg",
    },
  ];

  const [isCheckedFor, setIsCheckedFor] = useState({
    Cycling: false,
    Walking: false,
    Running: false,
  });

  const checkHandlerFor = (value) => {
    setIsCheckedFor((prevChecked) => ({
      ...prevChecked,
      [value]: !prevChecked[value],
    }));

    setSelectedEventTypes((prevSelected) =>
      isCheckedFor[value]
        ? prevSelected.filter((type) => type !== value)
        : [...prevSelected, value]
    );
  };

  const removeElement = (value) => {
    const updatedCheckedState = { ...isCheckedFor };
    updatedCheckedState[value] = false;
    setIsCheckedFor(updatedCheckedState);

    setSelectedEventTypes((prevEventType) =>
      prevEventType.filter((type) => type !== value)
    );
  };

  const getUpcomingEventQuery = usePostQuery(
    "getUpcomingEventQuery",
    GetUpcomingEvents,
    {}
  );

  const handleSearchChange = (event) => {
    const { value } = event.target;
    setSearchValue(value);
  };

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      getUpcomingEventQuery.mutate({
        search: searchValue,
        eventTypeID: selectedEventTypes,
        page: page,
        limit: limit,
      });
    }, 500);

    return () => clearTimeout(delaySearch);
  }, [searchValue, selectedEventTypes, page, limit]);

  const handleLoadMore = () => {
    const newLimit = limit + 6;
    const pageLimit = page;
    if (getUpcomingEventQuery?.data?.result?.length > newLimit) {
      setAllDataLoaded(true);
    }
    setPage(pageLimit);
    setLimit(newLimit);
  };

  return (
    <main>
      <section className="section-header-padding">
        <div className="container-fluid">
          <div className="mt-4">
            <div className="row m-2">
              <div
                className="col-md-12 h1 bebas-neue-font text-center"
                style={{ color: "rgb(179, 228, 41)" }}
              >
                UPCOMING EVENTS
              </div>
            </div>
          </div>
        </div>
        <div className="container px-4" style={{ marginTop: "-29px" }}>
          <div className="row">
            <div className="col-9 col-md-11 col-xs-10 col-xl-10 col-xxl-11">
              <div
                className="d-flex justify-content-center py-0 mt-5 mb-3 px-1 fs-2 fw-bold text-default-color"
                style={{ paddingBottom: "1rem !important" }}
              >
                <input
                  className="form-control me-2 rounded-pill p-2"
                  type="search"
                  id="txtSearch"
                  placeholder="Search"
                  aria-label="Search"
                  value={searchValue}
                  onChange={handleSearchChange}
                />
              </div>
            </div>
            <div className="col-3 col-md-1 col-xs-2 col-xl- col-xxl-1">
              <div className="d-flex justify-content-end py-0 mt-5 mb-3 px-2 fs-2 fw-bold">
                <Dropdown style={{ marginTop: "-7px" }} autoClose="outside">
                  <Dropdown.Toggle
                    variant="success"
                    id="dropdown-basic"
                    style={{
                      backgroundColor: "rgb(179, 228, 41)",
                      border: "none",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      style={{ color: "black" }}
                    >
                      <path
                        fill="currentColor"
                        d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"
                      />
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {options.map(({ value, label, icon }) => (
                      <CheckboxItem
                        key={value}
                        id={value}
                        isChecked={isCheckedFor[value]}
                        checkHandler={() => checkHandlerFor(value)}
                        label={label}
                        icon={icon}
                      />
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <Row>
              {options.map(
                ({ value, label, icon }) =>
                  isCheckedFor[value] && (
                    <div className="col-auto" key={value}>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm mt-2 p-2"
                        style={{
                          border: "none",
                          color: "black",
                          backgroundColor: "#b3e429",
                          borderRadius: "100px",
                        }}
                      >
                        {" "}
                        <img
                          src={icon}
                          className=""
                          alt={label}
                          style={{ marginTop: "-3px" }}
                          width={20}
                          height={20}
                        />{" "}
                        {label} &nbsp;
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 24 24"
                          onClick={() => removeElement(value)}
                        >
                          <path
                            fill="currentColor"
                            d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6z"
                          />
                        </svg>
                      </button>
                    </div>
                  )
              )}
            </Row>
          </div>
        </div>
      </section>
      <section className="event-margin">
        <Container className="py-4 px-0">
          <Row className="justify-content-center">
            {getUpcomingEventQuery?.data?.result?.map((item) => (
              <Card key={item.id} item={item} />
            ))}
            <SkeletonCard
              pathname={pathname}
              getUpcomingEventQuery={getUpcomingEventQuery}
            />
            {getUpcomingEventQuery?.data?.result?.length === 0 && <BlankPage />}
          </Row>

          {!allDataLoaded &&
            getUpcomingEventQuery?.data?.result?.length >= limit && (
              <Row className="justify-content-center">
                <div className="col-12">
                  <div className="button-container">
                    <hr
                      className="hr-text"
                      data-content="Load More"
                      onClick={handleLoadMore}
                    />
                  </div>
                </div>
              </Row>
            )}
        </Container>
      </section>
      <section className="section-background">
        <div className="container">
          <div className="row">
            {" "}
            <div className="col-12">
              <div className="d-flex justify-content-center flex-column flex-wrap pt-5">
                <div>
                  {" "}
                  <h1 className="bebas-neue-font text-center">
                    DOWNLOAD THE Move APP <br />
                    AND JOIN NOW!{" "}
                  </h1>
                </div>
                <div>
                  <h3 className="plus-jakarta-sans-font text-secondary text-center">
                    Let’s Get Moving!
                  </h3>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="d-flex flex-row flex-wrap gap-3 justify-content-center align-items-center pt-4 pb-5">
                <div>
                  <img
                    src="\media\assets\events\google-play.png"
                    alt=""
                    className="img-fluid d-block"
                  />
                </div>
                <div>
                  <img
                    src="\media\assets\events\app-store.png"
                    alt=""
                    className="img-fluid d-block"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Event;
